import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Router } from "@angular/router";
import { FormView } from 'app/form-views/domain/form-view';
import { FormViewService } from 'app/form-views/services/form-view.service';
import { QueryOptions } from 'app/core/commons/query.options';
import { FormViewData } from 'app/form-views/domain/form-view-data';
import { ConfirmationService } from "primeng/primeng";
import { GlobalAppService } from "../../../../core/commons/global-app.service";
import { MessageSeverity } from "../../../../core/commons/message-severity";


@Component({
    selector: 'app-form-view-data-list',
    templateUrl: './form-view-data-list.component.html',
    styleUrls: ['./form-view-data-list.component.scss']
})
export class FormViewDataListComponent implements OnInit {

    @ViewChild(MatPaginator)
    paginator: MatPaginator;
    @ViewChild(MatSort)
    sort: MatSort;
    data: FormViewData[];
    queryOptions: QueryOptions;
    displayedColumns = [ "name", "filledTime", "actions"]
    resultsLength = 0;
    viewsDataSource = new MatTableDataSource([]);

    constructor(private viewService: FormViewService,private appService: GlobalAppService, private confirmationService: ConfirmationService, private router: Router) {
    }

    ngOnInit() {
        this.queryOptions = new QueryOptions();
        this.queryOptions.size = 5;
        this.viewService.findAllFilled(this.queryOptions).subscribe(data => {
            this.data = data.content;
            this.resultsLength = data.totalElements;
            this.viewsDataSource.data = data.content;
        })
        this.paginator.page.subscribe(() => {
            this.queryOptions.page = this.paginator.pageIndex;
            this.queryOptions.size = this.paginator.pageSize;
            this.getData();
        });
    }

    getData(){
        this.viewService.findAllFilled(this.queryOptions).subscribe(data => {
            this.data = data.content;
            this.viewsDataSource.data = data.content;
        })
    }

    goToFill(selected: FormViewData){
        this.router.navigate(["home", "view", "filled", "detail", selected.id]);
    }

    goToEdition(selected: FormViewData){
        this.router.navigate(["home", "view", "update", selected.id]);
    }

    download(viewData: FormViewData){
        this.viewService.download(viewData.id).subscribe(res => {
            const fileURL = URL.createObjectURL(res);
            const downloadLink = document.createElement('a');
            downloadLink.href = fileURL;
            downloadLink.download = viewData.view.name + '_' +
                new Date(viewData.filledTime).toLocaleDateString() + '_' +
                viewData.id + '.pdf';
            downloadLink.click();
        });
    }

    delete(viewData: FormViewData){
        this.confirmationService.confirm({
            message: "¿está seguro que desea eliminar el documento?",
            icon: "fa ui-icon-delete-forever",
            accept: () => {
              this.appService.setLoading(true);
              this.viewService.delete(viewData.id).subscribe(
                b => {
                  this.appService.setLoading(false);
                  this.getData();
                  this.appService.sendMsg(
                    MessageSeverity.SUCCESS,
                    "Eliminado",
                    "Se ha eliminado el documento."
                  );
                },
                error => {
                  this.appService.setLoading(false);
                  this.appService.sendMsg(
                    MessageSeverity.ERROR,
                    "Error",
                    "No ha sido posible eliminar el documento. " +
                      error.json().message
                  );
                }
              );
            }
          });
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/data/form-view-data-list/form-view-data-list.component.ts